<template>
  <div class="box">
    <IosIndex v-if="isiOS == true"></IosIndex>
    <AndroidIndex v-if="isAndroid == true"></AndroidIndex>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import name from "@/components/name";
import IosIndex from "@/components/iosIndex";
import AndroidIndex from "@/components/androidIndex";

export default {
  components: {
    name,
    IosIndex,
    AndroidIndex,
  },

  data() {
    return {
      isAndroid: false,
      isiOS: false,
    };
  },

  created() {
    if (this.$root.loading) {
      var u = navigator.userAgent;
      if (u.indexOf("KuleWebview") > -1) {
        this.isAndroid = true;
      } else {
        // this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        this.isAndroid = !this.isiOS;
      }
    }
  },
  watch: {
    "$root.loading": {
      handler() {
        if (this.$root.loading) {
          var u = navigator.userAgent;
          if (u.indexOf("KuleWebview") > -1) {
            this.isAndroid = true;
          } else {
            this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            this.isAndroid = !this.isiOS;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped="scoped">
.box {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue